import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const InfrastructureChartsDataContext = createContext();

const InfrastructureChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.INFRASTRUCTURE_FAMILIES,
            url: 'governanceroom/dashboard/unifiedregistry/families/infrastructure'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              externalWallMeterial: data?.externalWallMeterial ?? [],
              houseSideWalk: data?.houseSideWalk ?? [],
              lighting: data?.lighting ?? [],
              pavementType: data?.pavementType ?? []
          }
        : {
              externalWallMeterial: [],
              houseSideWalk: [],
              lighting: [],
              pavementType: []
          };

 

    return (
        <InfrastructureChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </InfrastructureChartsDataContext.Provider>
    );
};

export default InfrastructureChartsDataProvider;
